import React, { memo, Suspense, type ReactNode } from 'react';

import { useRenderServerPlaceholder } from '@confluence/ssr-utilities/entry-points/useRenderServerPlaceholder.ts';

export interface HydrationSafeSuspenseProps {
	fallback?: ReactNode;
	children: ReactNode;
}

const HydrationSafeSuspenseContent = memo(
	function HydrationSafeSuspenseContent({
		children,
		fallback,
	}: {
		isLocked: boolean;
		children: ReactNode;
		fallback: ReactNode;
	}) {
		return <Suspense fallback={fallback}>{children}</Suspense>;
	},
	(_prevProps, nextProps) => {
		// Block updates while locked (during hydration)
		return nextProps.isLocked;
	},
);

/**
 * Suspense boundary that stays locked (via memo) until hydration has completed
 */
export function HydrationSafeSuspense({
	fallback = null,
	children,
}: HydrationSafeSuspenseProps): React.JSX.Element {
	const renderServerPlaceholder = useRenderServerPlaceholder();

	return (
		<HydrationSafeSuspenseContent isLocked={renderServerPlaceholder} fallback={fallback}>
			{children}
		</HydrationSafeSuspenseContent>
	);
}
